import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvironment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2386 6.51228V6.11931C11.2386 3.29199 8.94662 1 6.1193 1C3.29199 1 1 3.29199 1 6.1193L1 6.51227C1 9.20198 3.07431 11.4072 5.71048 11.6155V9.26318H6.71048V11.5978C9.25933 11.3047 11.2386 9.13965 11.2386 6.51228ZM0 6.51227C0 9.75449 2.5215 12.4078 5.71048 12.6181L5.71048 16L6.71048 16L6.71048 12.6034C9.81271 12.306 12.2386 9.69244 12.2386 6.51228V6.11931C12.2386 2.73971 9.4989 0 6.1193 0C2.73971 0 0 2.7397 0 6.1193V6.51227ZM9.47455 15.9998C9.47455 14.4006 10.7266 13.1313 12.2382 13.1313C13.7497 13.1313 15.0018 14.4006 15.0018 15.9998H16.0018C16.0018 13.8783 14.3315 12.1313 12.2382 12.1313C10.1448 12.1313 8.47455 13.8783 8.47455 15.9998H9.47455Z",
		fill: "currentColor"
	})
});
export default SvgEnvironment;
